<template>
  <page
    layout="single"
    class="rentalMessages"
    no-padding
  >
    <div class="rentalMessages__title">
      <md-icon name="info" />

      <h4>Messages</h4>
    </div>

    <div class="rentalMessages__button">
      <el-button type="primary">Accèder</el-button>
    </div>
  </page>
</template>

<script>
export default {
  name: 'RentalMessages'
}
</script>

<style lang="scss" scoped>
$c: '.rentalMessages';

#{$c} {
  padding: 26px !important;
  line-height: 200%;

  &__title {
    display: flex;

    i {
      position: relative;
      top: 5px;
    }

    h4 {
      padding-left: 5px;
      font-size: 22px !important;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>